import { initInstaFeed } from "../components/instaFeed"

const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 900px)" ) ];
const domReady = () => {
  initInstaFeed();
};

export default function RAKUICHI () {
  w.addEventListener('load', domReady);
}